/*
  Do not edit directly
  Generated on Fri, 16 Dec 2022 15:45:05 GMT
*/
/**
 * Do not edit directly
 * Generated on Fri, 16 Dec 2022 15:45:05 GMT
 */
/*
  Do not edit directly
  Generated on Fri, 16 Dec 2022 15:45:05 GMT
*/
body.light {
  --color-background: #ffffff;
  --color-background-secondary: #f4f5f7;
  --color-background-inverse: #182027;
  --color-background-gray: #cfd8dd;
  --color-background-disabled: #ecedee;
  --color-background-highlight: #fee3dc;
  --color-background-raised: #ffffff;
  --color-background-edit: #ffffff;
  --color-background-gray-emp: #a4b1b8;
  --color-hover: #e9f1fa;
  --color-curtain: #000000;
  --color-border: #a4b1b8;
  --color-border-disabled: #cfd8dd;
  --color-border-grid: #f4f5f7;
  --color-border-de-emp: #cfd8dd;
  --color-selection: #da3b11;
  --color-logo: #fa4616;
  --color-foreground: #273139;
  --color-foreground-light: #6b7882;
  --color-foreground-emp: #182027;
  --color-foreground-de-emp: #526069;
  --color-foreground-disable: #8a97a0;
  --color-foreground-inverse: #f8f9fa;
  --color-foreground-highlight: #da3b11;
  --color-foreground-highlight-selected: rgba(218, 59, 17, 0.1);
  --color-foreground-highlight-selected-hover: rgba(218, 59, 17, 0.15);
  --color-foreground-link: #0067df;
  --color-foreground-link-pressed: #00489d;
  --color-foreground-inv-de-emp: #cfd8dd;
  --color-primary: #0067df;
  --color-primary-lighter: #badaff;
  --color-primary-darker: #00489d;
  --color-primary-hover: #0061d3;
  --color-primary-focused: #0061d3;
  --color-primary-pressed: #0067df;
  --color-secondary-focused: #e9f1fa;
  --color-secondary-pressed: #b2d2f3;
  --color-chip-default-background: #cfd8dd;
  --color-chip-error-background: #fff0f1;
  --color-chip-warning-background: #fff3db;
  --color-chip-info-background: #e9f1fa;
  --color-chip-success-background: #eeffe5;
  --color-error-icon: #cc3d45;
  --color-error-text: #a6040a;
  --color-error-background: #fff0f1;
  --color-error-foreground-inverse: #ff8484;
  --color-info-foreground: #1665b3;
  --color-info-icon: #1976d2;
  --color-info-text: #1665b3;
  --color-info-foreground-inverse: #42a1ff;
  --color-info-background: #e9f1fa;
  --color-success-icon: #6eb84a;
  --color-success-text: #038108;
  --color-success-background: #eeffe5;
  --color-success-foreground-inverse: #74c94b;
  --color-warning-icon: #ffb40e;
  --color-warning-text: #9e6100;
  --color-warning-background: #fff3db;
  --color-warning-foreground-inverse: #ffbb27;
  --color-icon-default: #526069;
  --color-icon-inverted-default: #cfd8dd;
  --color-toggle-off-hover: rgba(82, 96, 105, 0.08);
  --color-toggle-off-focus: rgba(82, 96, 105, 0.08);
  --color-toggle-off-pressed: rgba(82, 96, 105, 0.12);
  --color-toggle-on-hover: rgba(0, 103, 223, 0.08);
  --color-toggle-on-focus: rgba(0, 103, 223, 0.08);
  --color-toggle-on-pressed: rgba(0, 103, 223, 0.12);
  --color-callout-background: #00489d;
  --color-warn: #b6242b;
  --color-warn-darker: #a6040a;
  --color-warn-hover: rgba(182, 36, 43, 0.04);
  --color-warn-focus: rgba(182, 36, 43, 0.12);
  --color-warn-pressed: rgba(182, 36, 43, 0.08);
  --color-carousel-background: #f5f9fe;
  --color-icon-button-hover: rgba(82, 96, 105, 0.08);
  --color-icon-button-focus: rgba(82, 96, 105, 0.08);
  --color-icon-button-pressed: rgba(82, 96, 105, 0.12);
  --border: 1px solid #a4b1b8;
  color-scheme: light;
}

body.dark {
  --color-background: #182027;
  --color-background-secondary: #273139;
  --color-background-inverse: #f8f9fa;
  --color-background-gray: #526069;
  --color-background-disabled: #273139;
  --color-background-highlight: #3c383c;
  --color-background-raised: #273139;
  --color-background-edit: rgba(0, 0, 0, 0.6);
  --color-background-gray-emp: #8a97a0;
  --color-hover: #2d3d4d;
  --color-curtain: #000000;
  --color-border: #8a97a0;
  --color-border-disabled: #526069;
  --color-border-grid: #273139;
  --color-border-de-emp: #526069;
  --color-selection: #ff8f70;
  --color-logo: #ffffff;
  --color-foreground: #f4f5f7;
  --color-foreground-light: #a4b1b8;
  --color-foreground-emp: #f8f9fa;
  --color-foreground-de-emp: #cfd8dd;
  --color-foreground-disable: #a4b1b8;
  --color-foreground-inverse: #182027;
  --color-foreground-highlight: #ff8f70;
  --color-foreground-highlight-selected: rgba(255, 143, 112, 0.1);
  --color-foreground-highlight-selected-hover: rgba(255, 143, 112, 0.15);
  --color-foreground-link: #66adff;
  --color-foreground-link-pressed: #badaff;
  --color-foreground-inv-de-emp: #526069;
  --color-primary: #66adff;
  --color-primary-lighter: #00489d;
  --color-primary-darker: #badaff;
  --color-primary-hover: #87bfff;
  --color-primary-focused: #87bfff;
  --color-primary-pressed: #66adff;
  --color-secondary-focused: #2d3d4d;
  --color-secondary-pressed: #11508d;
  --color-chip-default-background: #526069;
  --color-chip-error-background: #000000;
  --color-chip-warning-background: #000000;
  --color-chip-info-background: #000000;
  --color-chip-success-background: #000000;
  --color-error-icon: #ff8484;
  --color-error-text: #ff8484;
  --color-error-background: #000000;
  --color-error-foreground-inverse: #cc3d45;
  --color-info-foreground: #42a1ff;
  --color-info-icon: #42a1ff;
  --color-info-text: #42a1ff;
  --color-info-foreground-inverse: #1976d2;
  --color-info-background: #000000;
  --color-success-icon: #74c94b;
  --color-success-text: #74c94b;
  --color-success-background: #000000;
  --color-success-foreground-inverse: #6eb84a;
  --color-warning-icon: #ffbb27;
  --color-warning-text: #ffe19e;
  --color-warning-background: #000000;
  --color-warning-foreground-inverse: #ffb40e;
  --color-icon-default: #cfd8dd;
  --color-icon-inverted-default: #526069;
  --color-toggle-off-hover: rgba(207, 216, 221, 0.08);
  --color-toggle-off-focus: rgba(207, 216, 221, 0.08);
  --color-toggle-off-pressed: rgba(207, 216, 221, 0.12);
  --color-toggle-on-hover: rgba(102, 173, 255, 0.08);
  --color-toggle-on-focus: rgba(102, 173, 255, 0.08);
  --color-toggle-on-pressed: rgba(102, 173, 255, 0.12);
  --color-callout-background: #00489d;
  --color-warn: #ff8484;
  --color-warn-darker: #ffadad;
  --color-warn-hover: rgba(255, 132, 132, 0.04);
  --color-warn-focus: rgba(255, 132, 132, 0.12);
  --color-warn-pressed: rgba(255, 132, 132, 0.08);
  --color-carousel-background: #1b2630;
  --color-icon-button-hover: rgba(207, 216, 221, 0.08);
  --color-icon-button-focus: rgba(207, 216, 221, 0.08);
  --color-icon-button-pressed: rgba(207, 216, 221, 0.12);
  --border: 1px solid #8a97a0;
  color-scheme: dark;
}

/* ------------------------------
 * -- Main Global Styling -------
 * ------------------------------ */
._pendo-guide-container_ {
  /* -- Guide border, shadow, background, etc. -- */
  background-color: var(--color-background-raised) !important;
  border-color: var(--color-border) !important;
  color: var(--color-foreground) !important;
  border-radius: 3px !important;
}

._pendo-guide-container_ ._pendo-guide-content_ {
  /* -- Content area -- use for font attributes, padding, etc. */
  color: var(--color-foreground) !important;
}

/* ------------------------------
 * -- Lightbox Specific Styling -
 * ------------------------------ */
._pendo-backdrop_ {
  /* The backdrop displayed behind lightboxes */
  background-color: var(--color-curtain) !important;
  opacity: 0.5 !important;
}

/* ------------------------------
 * -- Tooltip Specific Styling --
 * ------------------------------ */
/* -- Pointer on the edge of the tooltip -- */
._pendo-guide-arrow-top_ {
  border-bottom-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-left_ {
  border-right-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-right_ {
  border-left-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-bottom_ {
  border-top-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-border-top_ {
  border-bottom-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-border-left_ {
  border-right-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-border-right_ {
  border-left-color: var(--color-background-raised) !important;
}

._pendo-guide-arrow-border-bottom_ {
  border-top-color: var(--color-background-raised) !important;
}

/* ------------------------------
 * -- Launcher Styling ----------
 * ------------------------------ */
._pendo-launcher_ ._pendo-launcher-header_ {
  /* -- Launcher header area -- */
  border-bottom-color: var(--color-border) !important;
}

._pendo-launcher_ ._pendo-launcher-header_ ._pendo-launcher-title_ {
  /* -- Launcher header area text styles -- */
  font-family: inherit;
  color: var(--color-foreground-de-emp) !important;
}

._pendo-launcher_ ._pendo-launcher-header_ ._pendo-launcher-search-box_ {
  /* -- Launcher search area (if enabled) -- */
  border-color: var(--color-border) !important;
  background-color: var(--color-background-gray-emp) !important;
}

._pendo-launcher_ ._pendo-launcher-footer_ {
  /* -- Launcher footer area -- */
  color: var(--color-foreground-de-emp) !important;
}

/* ------------------------------
 * -- Poll Styling --------------
 * ------------------------------ */
._pendo-guide-container_ ._pendo-poll-question_ ._pendo-poll-npsrating-choices_ label {
  /* -- NPS Poll individual rating - the number scale items -- */
  color: var(--color-foreground-de-emp) !important;
  border-color: var(--color-border) !important;
}

._pendo-guide-container_ ._pendo-poll-question_ ._pendo-poll-npsrating-choices_ label span {
  /* -- NPS Poll individual rating - accompanying text for number scale items -- */
  color: var(--color-foreground-de-emp) !important;
}

._pendo-guide-container_ ._pendo-poll-npsreason_ textarea {
  border-color: var(--color-border) !important;
  width: 100% !important;
}

._pendo-guide-container_ ._pendo-poll-submit_ {
  /* -- Submit button styles -- */
  background-color: var(--color-primary) !important;
  color: var(--color-foreground-inverse) !important;
  font-family: inherit !important;
  border-color: var(--color-primary) !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-radius: 3px !important;
}

._pendo-poll_ ._pendo-poll-freeform_ textarea {
  color: var(--color-foreground) !important;
}

._pendo-poll_ ._pendo-poll-npsrating_ ._pendo-poll-npsrating-choices_ label {
  color: var(--color-foreground-light) !important;
}

._pendo-poll_ ._pendo-poll-npsrating_ ._pendo-poll-npsrating-choices_ label span {
  color: var(--color-foreground-light) !important;
}

._pendo-poll_ ._pendo-poll-npsrating_ ._pendo-poll-npsrating-choices_ label:hover {
  border-color: var(--color-border) !important;
  background-color: var(--color-background-gray-emp) !important;
  color: var(--color-foreground-inverse) !important;
}

._pendo-poll_ ._pendo-poll-npsrating_ ._pendo-poll-npsrating-choices_ ._pendo-poll-selected_ {
  border-color: var(--color-foreground-de-emp) !important;
  background-color: var(--color-foreground-de-emp) !important;
  color: var(--color-foreground-inverse) !important;
}

._pendo-poll_ ._pendo-poll-npsreason_ {
  border-top-color: var(--color-border) !important;
}

._pendo-poll_ ._pendo-poll-npsreason_ textarea {
  border-color: var(--color-border) !important;
}

/* ------------------------------
 * -- Your Custom Classes/IDs ---
 * ------------------------------ */
._pendo_row {
  background-color: transparent !important;
}

.bb-text {
  color: var(--color-foreground) !important;
}

._pendo-close-guide {
  color: var(--color-foreground-emp) !important;
  font-family: inherit !important;
  font-size: 24px !important;
  height: 24px !important;
  width: 24px !important;
  border-radius: 50% !important;
  top: 10px !important;
  right: 10px !important;
}

._pendo-backdrop, .pendo-backdrop-region-right, .pendo-backdrop-region-top, .pendo-backdrop-region-bottom, .pendo-backdrop-region-left {
  background-color: var(--color-curtain) !important;
  opacity: 0.5 !important;
}

._pendo-close-guide:hover {
  background: var(--color-background-secondary) !important;
}

._pendo-guide-container_ {
  background-color: var(--color-background-raised) !important;
}

._pendo-button-primaryButton {
  background-color: var(--color-primary) !important;
  color: var(--color-foreground-inverse) !important;
  font-family: inherit !important;
  border-color: var(--color-primary) !important;
  border-width: 1px !important;
  border-style: solid !important;
}

._pendo-button-primaryButton:hover {
  background-color: var(--color-primary-hover) !important;
}

._pendo-button-primaryButton:focused {
  background-color: var(--color-primary-focused) !important;
}

._pendo-button-secondaryButton {
  background-color: var(--color-background-raised) !important;
  color: var(--color-primary) !important;
  border-color: var(--color-border) !important;
  border-width: 1px !important;
  border-style: solid !important;
}

._pendo-button-secondaryButton:hover, ._pendo-button-tertiaryButton:hover {
  background-color: var(--color-hover) !important;
}

._pendo-button-tertiaryButton {
  /* background: var(--color-background-raised); */
  color: var(--color-primary) !important;
  border-color: var(--color-background-raised) !important;
  border-width: 1px !important;
  border-style: solid !important;
}

/* Text poll */
._pendo-open-text-poll-input {
  background-color: var(--color-background) !important;
  color: inherit !important;
  border-radius: 3px !important;
  font-family: inherit !important;
  width: 100% !important;
}

/* NPS/Poll Buttons */
._pendo-nps-poll-wrapper input[type=radio] + label,
._pendo-number-scale-poll-wrapper input[type=radio] + label {
  color: var(--color-primary) !important;
  border-color: var(--color-border) !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: inherit !important;
}

._pendo-number-scale-poll-wrapper div {
  color: var(--color-foreground-disable) !important;
}

._pendo-nps-poll-wrapper input[type=radio]:not(:checked) + label,
._pendo-number-scale-poll-wrapper input[type=radio]:not(:checked) + label {
  background-color: var(--color-background-raised) !important;
}

._pendo-nps-poll-wrapper input[type=radio]:hover + label,
._pendo-number-scale-poll-wrapper input[type=radio]:hover + label {
  background-color: var(--color-hover) !important;
}

._pendo-nps-poll-wrapper input[type=radio]:checked + label,
._pendo-number-scale-poll-wrapper input[type=radio]:checked + label {
  background-color: var(--color-secondary-pressed) !important;
}

._pendo-nps-poll-wrapper ._pendo-text-plain,
._pendo-nps-poll-wrapper ._pendo-nps-poll-upperbound-label,
._pendo-nps-poll-wrapper ._pendo-nps-poll-lowerbound-label {
  color: var(--color-foreground-de-emp) !important;
}

._pendo-step-container-styles {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2), 0px 1px 5px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14) !important;
  border-color: var(--color-background-raised) !important;
  color: var(--color-foreground) !important;
  padding: 24px !important;
  padding-top: 20px !important;
  background-color: var(--color-background-raised) !important;
  border-radius: 3px !important;
}

._pendo-step-container-styles[data-caret-enabled=true] {
  background-color: #00489d !important;
  color: #ffffff !important;
  border-color: #00489d !important;
}
._pendo-step-container-styles[data-caret-enabled=true] .bb-text {
  color: #ffffff !important;
  font-size: inherit !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-text-title, ._pendo-step-container-styles[data-caret-enabled=true] ._pendo-text-subTitle {
  font-size: 20px !important;
  line-height: 24px !important;
  font-weight: 600 !important;
  margin-bottom: 6px !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-text-paragraph {
  line-height: 21px !important;
  margin-right: 6px !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-close-guide {
  color: #ffffff !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-close-guide:hover, ._pendo-step-container-styles[data-caret-enabled=true] ._pendo-close-guide:focus {
  background-color: #273139 !important;
  cursor: pointer !important;
}
._pendo-step-container-styles[data-caret-enabled=true] .pendo-mock-flexbox-row {
  margin-top: 24px !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button {
  font-weight: 600 !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-primaryButton {
  background-color: #ffffff !important;
  color: #0067df !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-primaryButton:hover, ._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-primaryButton:focus {
  background-color: #00336f !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-color: #00336f !important;
  cursor: pointer !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-secondaryButton {
  background-color: transparent !important;
  color: #ffffff !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-secondaryButton:hover, ._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-secondaryButton:focus {
  background-color: #ffffff !important;
  color: #0067df !important;
  font-weight: 600 !important;
  border-color: #ffffff !important;
  cursor: pointer !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-tertiaryButton {
  background-color: transparent !important;
  color: #ffffff !important;
}
._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-tertiaryButton:hover, ._pendo-step-container-styles[data-caret-enabled=true] ._pendo-button-tertiaryButton:focus {
  background-color: #00336f !important;
  color: #87bfff !important;
  font-weight: 600 !important;
  border-color: #ffffff !important;
  cursor: pointer !important;
}

._pendo-step-container-styles[data-caret-enabled=true] + .pendo-tooltip-caret[style*="); top:"], ._pendo-step-container-styles[data-caret-enabled=true] ~ .pendo-tooltip-caret-border[style*="); top:"] {
  border-bottom-color: #00489d !important;
}

._pendo-step-container-styles[data-caret-enabled=true] + .pendo-tooltip-caret[style*="); right:"], ._pendo-step-container-styles[data-caret-enabled=true] ~ .pendo-tooltip-caret-border[style*="); right:"] {
  border-left-color: #00489d !important;
}

._pendo-step-container-styles[data-caret-enabled=true] + .pendo-tooltip-caret[style*="); bottom:"], ._pendo-step-container-styles[data-caret-enabled=true] ~ .pendo-tooltip-caret-border[style*="); bottom:"] {
  border-top-color: #00489d !important;
}

._pendo-step-container-styles[data-caret-enabled=true] + .pendo-tooltip-caret[style*="); left"], ._pendo-step-container-styles[data-caret-enabled=true] ~ .pendo-tooltip-caret-border[style*="); left:"] {
  border-right-color: #00489d !important;
}

/* Step Container Bottom Aligned */
._pendo-step-container-size[data-vertical-alignment="Bottom Aligned"] {
  height: auto !important;
}

._pendo-step-container-size[data-vertical-alignment="Bottom Aligned"] ._pendo-step-container-styles {
  background: var(--color-background-raised) !important;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.2), 0px 1px 5px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14) !important;
}

._pendo-nps-open-text-poll-question {
  color: var(--color-foreground) !important;
}

/* Font color overrides */
._pendo-text-title,
._pendo-text-plain,
._pendo-simple-text,
._pendo-text-subTitle,
._pendo-text-paragraph,
._pendo-nps-poll-question,
[id^=pendo-radio-select-], .pendo-radio,
._pendo-text-paragraph._pendo-open-text-poll-question._pendo-nps-open-text-poll-question {
  color: inherit !important;
}

._pendo-text-link {
  color: var(--color-primary) !important;
}

._pendo-text-link:hover {
  text-decoration: underline !important;
  color: var(--color-primary-hover) !important;
}

/* Not sure what to do to Make Pendo's radio buttons not look like hot garbage */
[id^=pendo-radio-select-] span {
  display: flex !important;
  align-items: center;
}

[id^=pendo-radio-select-] .pendo-radio {
  color: var(--color-foreground) !important;
}

[id^=pendo-radio-select-] input[type=radio] {
  /* For iOS < 15 to remove gradient background */
  background-color: var(--color-background-raised) !important;
  border: 0.15em solid var(--color-foreground-de-emp) !important;
}

[id^=pendo-radio-select-] input[type=radio]::before {
  content: "" !important;
  width: 0.6em !important;
  height: 0.6em !important;
  border-radius: 50% !important;
  transform: scale(0) !important;
  transition: 120ms transform ease-in-out !important;
  box-shadow: inset 1em 1em var(--color-primary) !important;
  background-color: var(--color-primary) !important;
}

[id^=pendo-radio-select-] input[type=radio]:checked::before {
  transform: scale(1);
}

select._pendo-multi-choice-poll-select {
  color: inherit !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 10px 0 0.5em !important;
  margin: 0 !important;
  width: 100% !important;
  font-family: inherit !important;
  line-height: inherit !important;
  border-radius: 3px !important;
}

._pendo-multi-choice-poll-select-border {
  background-color: inherit !important;
}

._pendo-multi-choice-poll-select-border[data-_pendo-multi-choice-poll-select-border-1] {
  border: none !important;
}

._pendo-multi-choice-poll-select-border[data-_pendo-multi-choice-poll-select-border-1]:hover {
  border-color: var(--color-foreground-de-emp) !important;
}

._pendo-multi-choice-poll-select-border option._pendo-option {
  background-color: var(--color-background-raised) !important;
}

._pendo_badge_ {
  background-color: var(--color-background) !important;
}

._pendo-badge-text {
  color: var(--color-primary) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}